import Iframe from 'features/iframe';
// import toolsPage from 'features/tools-page';
// import aboutTda from 'features/about-tda';
import error404 from 'features/error-404';
import peIFrame from 'components/payment-estimator-iframe';
// import privacyPolicy from 'features/privacy-policy';
import siteMap from 'features/site-map';
import gbscion from 'features/goodbye-scion';
import dealerSeo from 'features/dealer-seo';
import vehicleStrip from 'features/vehicle-strip/vehicle.strip';
import localDisclaimers from 'features/local-disclaimers';
// import tssPage from 'features/tss/tss-page';
import h2hPage from 'features/h2h/h2h-page';

export default {
  Iframe: Iframe,
  // toolsPage: toolsPage,
  // aboutTda: aboutTda,
  error404: error404,
  peIFrame: peIFrame,
  // privacyPolicy: privacyPolicy,
  siteMap: siteMap,
  gbscion: gbscion,
  dealerSeo: dealerSeo,
  localDisclaimers: localDisclaimers,
  // tssPage: tssPage,
  h2hPage: h2hPage,
  vehicleStrip: vehicleStrip,
};
